<template>
  <div>
    <div class="ibox animated fadeInLeftBig">
      <div class="ibox-title" style="padding: 16px">
        <h3>
          <span style="text-transform: uppercase; color: #08b9b3">{{
            crudName
          }}</span>

         
          <router-link
            :to="prepareUrl(endPoint) + 'add'"
            class="btn btn-add"
            v-show="enableAdd"
            style="float: right; margin-top: -5px"
            >{{ newText }}</router-link
          >
        </h3>
      </div>

      <div class="ibox-content">
        <v-server-table
          ref="table"
          :name="table"
          :url="url"
          :columns="columns"
          :options="options"
        >
          <div slot="actions" slot-scope="props">
            <button
              v-show="enableView"
              data-toggle="tooltip"
              title="Consultar"
              class="btn btn-crud info fas fa-eye"
              @click="view(props.row.id)"
              style="margin-bottom: 3px"
            ></button>
            <button
              v-show="enableEdit"
              data-toggle="tooltip"
              title="edit"
              class="btn btn-crud edit fas fa-pencil-alt"
              @click="edit(props.row.id)"
              style="margin-bottom: 3px"
            ></button>
            <button
              v-show="enableDelete"
              data-toggle="tooltip"
              title="Deletar"
              class="btn btn-crud delete fa fa-trash"
              @click="destroy(props, props.row, props.index)"
              style="margin-bottom: 3px"
            ></button>
            <button
              v-show="enableSetStatus"
              data-toggle="tooltip"
              title="Ativa/Inativa"
              class="btn btn-crud view fa fa-check"
              @click="active(props, props.row, props.index)"
              style="margin-bottom: 3px"
            ></button>
            <a
              v-show="enableSetTestNotification"
              data-toggle="tooltip"
              title="Notificações de Teste"
              class="btn btn-success fa fa-paper-plane"
              @click="setTestNotification(props, props.row, props.index)"
              style="margin-bottom: 3px"
            ></a>
            <a
              v-show="boxUpload"
              data-toggle="tooltip"
              title="Upload"
              class="btn btn-danger fa fa-upload"
              @click="uploadBoxImage(props, props.row, props.index)"
              style="margin-bottom: 3px"
            ></a>

            <template v-for="extra in extra">
              <template v-if="!extra.conditionated">
                <button
                  data-toggle="tooltip"
                  :title="extra.title"
                  :key="extra.id"
                  :class="extra.class"
                  @click="callExtra(extra.name, props, props.row, props.index)"
                  style="margin-bottom: 3px"
                >
                  {{ extra.label }}
                </button>
              </template>
              <template v-if="extra.conditionated && props.row[extra.attr]">
                <button
                  data-toggle="tooltip"
                  :title="extra.title"
                  :key="extra.id"
                  :class="extra.class"
                  @click="callExtra(extra.name, props, props.row, props.index)"
                  style="margin-bottom: 3px"
                >
                  {{ extra.label }}
                </button>
              </template>
            </template>
          </div>
          <div
            slot="box_photo"
            slot-scope="props"
            v-bind:id="'box-' + props.row.id"
          >
            <img
              :src="props.row.box_photo"
              alt
              class="photo"
              style="width: 80px"
            />
            <span>{{ props.row.box_photo }}</span>
          </div>
          <div slot="photo" slot-scope="props">
            <img :src="props.row.photo" alt class="photo" width="100%" />
          </div>
          <div slot="cover_photo" slot-scope="props">
            <img :src="props.row.cover_photo" alt class="photo" width="100%" />
          </div>
        </v-server-table>
      </div>
    </div>
  </div>
</template>

<script>
import { Pagination } from "vue-pagination-2";

export default {
  data: function () {
    return {
      records: [],
      pages: [],
      tableData: [],
    };
  },
  props: {
    crudName: String,
    newText: String,
    table: String,
    columns: Array,
    options: Object,
    endPoint: String,
    enableAdd: Boolean,
    enableEdit: Boolean,
    enableDelete: Boolean,
    enableView: Boolean,
    enableAutoRefresh: Boolean,
    enableSetStatus: Boolean,
    enableSetTestNotification: Boolean,
    boxUpload: Boolean,
    extra: Array,
  },
  computed: {
    url() {
      let aux = this.endPoint.includes("?") ? "" : "";
      return this.$store.getters.api + this.endPoint + aux;
    },
  },
  methods: {
    pollData() {
      if (this.enableAutoRefresh == true) {
        this.polling = setInterval(() => {
          this.refresh();
        }, 5000);
      }
    },
    refresh() {
      if (this.$route.path == "/orders") {
        console.info("Base crud auto refresh");
        this.$refs.table.refresh();
      }
    },
    callExtra(name, props, row, index) {
      this.$emit(name, {
        props,
        row,
        index,
      });
    },
    edit(id) {
      this.$router.push({
        path: this.prepareUrl(this.endPoint) + "edit/" + id,
      });
    },
    view(id) {
      this.$router.push({
        path: this.prepareUrl(this.endPoint) + "view/" + id,
      });
    },
    destroy(props, row, index) {
      const self = this;

      swal({
        title: "Deseja deletar o registro?",
        text: "Essa operação não pode ser desfeita",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Sim, deletar!",
        showLoaderOnConfirm: true,
        buttons: {
          catch: {
            text: "Não",
            value: "cancel",
            className: "btn-danger",
          },
          confirm: {
            text: "Sim",
            value: "confirm",
          },
        },
      }).then((value) => {
        switch (value) {
          case "cancel":
            swal("Cancelado", "O registro não foi excluido!", "info");
            break;
          case "confirm":
            self.$http
              .delete(this.prepareUrl(this.url) + row.id, {
                id: row.id,
              })
              .then((response) => {
                const tableData = self.$refs.table.tableData;
                tableData.splice(
                  tableData.indexOf(tableData.find((o) => o.id === row.id)),
                  1
                );
                swal("Sucesso", "Registro excluído com sucesso!", "success");
              });
            break;
        }
      });
    },
    active(props, row, index) {
      const self = this;

      swal({
        title: "Mudança de Status",
        text: "Deseja ativar/inativar o registro?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Sim",
        showLoaderOnConfirm: true,
        buttons: {
          catch: {
            text: "Não",
            value: "cancel",
            className: "btn-danger",
          },
          confirm: {
            text: "Sim",
            value: "confirm",
          },
        },
      }).then((value) => {
        switch (value) {
          case "cancel":
            swal("Cancelado", "Ação cancelada!", "info");
            break;
          case "confirm":
            row.status = row.status === 2 ? 1 : 2;

            self.$http
              .put(this.prepareUrl(this.url) + row.id, {
                status: row.status,
              })
              .then((response) => {
                swal("Sucesso", "Registro alterado com sucesso!", "success");
              });
            break;
        }
      });
    },
    setTestNotification(props, row, index) {
      const self = this;

      swal({
        title: "Mudança de Status",
        text: "Deseja ativar/inativar recebimento de notificações de teste?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Sim",
        showLoaderOnConfirm: true,
        buttons: {
          catch: {
            text: "Não",
            value: "cancel",
            className: "btn-danger",
          },
          confirm: {
            text: "Sim",
            value: "confirm",
          },
        },
      }).then((value) => {
        switch (value) {
          case "cancel":
            swal("Cancelado", "Ação cancelada!", "info");
            break;
          case "confirm":
            row.test_notifications = !row.test_notifications;
            self.$http
              .put(this.prepareUrl(this.url) + row.id, {
                test_notifications: row.test_notifications,
              })
              .then((response) => {
                swal("Sucesso", "Registro alterado com sucesso!", "success");
              });
            break;
        }
      });
    },
    uploadBoxImage(props, row, index) {
      let modal = $("#uploadBoxImage");

      modal.find("#id").val(row.id);
      modal.modal("show");
    },
    prepareUrl(url) {
      if (url.includes("?")) {
        return url.split("?")[0];
      }

      return url;
    },
  },
  mounted() {
    this.pollData();
  },
  components: {
    Pagination,
  },
};
</script>

<style scoped>
.photo {
  max-height: 180px;
}
.VueTables__row {
  font-size: 16px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Base/BaseCrud.vue